import React from 'react';
import Image from 'next/image';

const SingleCoinPrediction: React.FC = () => {
    return (
        <div className='w-full flex justify-center h-40 relative rounded-xl overflow-hidden'>
            <Image
                src='/images/prediction_blur.png'
                alt='prediction'
                width={1200}
                height={200}
                className='aspect-video object-cover blur-md h-full w-full'
            />
            <span className='absolute w-full h-full flex justify-center items-center text-primary-dark dark:text-white font-bold text-2xl'>
                به زودی
            </span>
        </div>
    );
};

export default SingleCoinPrediction;
